import compact from 'lodash/compact'
import filter from 'lodash/filter'
import includes from 'lodash/includes'
import join from 'lodash/join'
import { MutableRefObject, useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'

import { Product as ProductMParticle } from '@Events/ECommerce'
import { gtm, Product as ProductGTM } from '@Globals/Google/DataLayer'
import { useMParticle } from '@Globals/MParticle/useMParticle'

type ID = string | number | null

interface WishList {
  isSelected: (productId: ID) => boolean
  itemsInWishlist: number
  wishListHandler: (event, showAnimation: MutableRefObject<boolean>) => void
}

export const useWishList = (
  id: ID = null,
  gtmProduct: ProductGTM | null = null,
  mParticleProduct: ProductMParticle | null = null,
): WishList => {
  const [cookies, setCookie] = useCookies()
  const [wishList, setWishList] = useState([])
  const { logProductAction } = useMParticle()

  const products = compact([mParticleProduct])

  useEffect(() => {
    if (cookies.th_wishlist) {
      setWishList(cookies.th_wishlist)
    }
  }, [cookies.th_wishlist])

  return {
    itemsInWishlist: wishList?.length,
    wishListHandler: (event, showAnimation) => {
      event.preventDefault()
      event.stopPropagation()
      if (includes(wishList, id)) {
        const newIds = filter(wishList, itemId => itemId !== id)
        setCookie('th_wishlist', newIds, { path: '/' })
        // eslint-disable-next-line no-param-reassign
        showAnimation.current = false
        logProductAction({
          custom_attributes: {
            category_ids: 'inherit',
            source_id: 'inherit',
          },
          eventName: 'remove_from_wishlist',
          products,
        })
      } else {
        setCookie('th_wishlist', [...wishList, id], { path: '/' })
        // eslint-disable-next-line no-param-reassign
        showAnimation.current = true
        logProductAction({
          custom_attributes: {
            category_ids: 'inherit',
            source_id: 'inherit',
          },
          eventName: 'add_to_wishlist',
          products,
        })

        if (gtmProduct?.id) {
          gtm({
            // TODO: These categoryIds should be consolidated in GTM. But current GTM variable setup is using both.
            categoryContentIds: join(gtmProduct.categoryIDs, ','),
            categoryIds: join(gtmProduct.categoryIDs, ','),
            event: 'addToWishList',
            productData: {
              id: gtmProduct.id,
              localPrice: gtmProduct?.localPrice,
            },
            productName: gtmProduct.name || '',
            productId: parseInt(gtmProduct.id, 10),
          })
        }
      }
    },
    isSelected: (productId: ID) => includes(wishList, productId),
  }
}
